/**
 * Combo's (§3.5, §13, §14).
 *
 * - 5-kaarttype-combo (≥5 van de 6 types in 1 beurt, alleen vs. eindbazen) staat
 *   per eindbaas als `combo.bossHpLoss` in de chakra-data.
 * - Cross-chakra paar-combo's (origin X + origin X+1 in 1 beurt): hieronder.
 * - Volledige balans (alle 7 origins in 1 beurt): hieronder.
 * - MEGA COMBO (4 meesterschapskaarten, alleen Theluun, §13): hieronder.
 *
 * BEWUSTE CONFLICT-RESOLUTIE: §14 noemt voor "alle 7 origins bij Theluun" +40
 * Verbinding, maar §13 (Theluun's eigen, specifiekere sectie) zegt +20 Verbinding
 * voor alle-7 en reserveert +40 voor de 4-meesterschaps-MEGA-combo. We volgen
 * §13. Buiten Theluun geeft volledige balans baas −25 HP (§14).
 */
import type { KaartType, Origin } from './types';

/** Effect van een combo; engine interpreteert de gezette velden. */
export interface ComboEffect {
  energy?: number;
  energyNext?: number;
  heal?: number;
  dmg?: number;
  verbinding?: number;
  cleanse?: 'all';
  /** Type-gefilterde output-buff (bv. praktijkkaarten +2, N beurten). */
  buffType?: { type: KaartType; amt: number; turns: number };
  /** Speel alle 7 mantra-tonen samen (audio). */
  allTones?: boolean;
}

export interface CrossCombo {
  paar: [Origin, Origin];
  naam: string;
  effect: ComboEffect;
}

/** §14 — paar-combo's (beide origins in dezelfde beurt). */
export const CROSS_COMBOS: CrossCombo[] = [
  { paar: [1, 2], naam: 'Veiligheid voedt creativiteit', effect: { energyNext: 2 } },
  { paar: [2, 3], naam: 'Creativiteit voedt kracht', effect: { buffType: { type: 'p', amt: 2, turns: 2 } } },
  { paar: [3, 4], naam: 'Kracht door compassie', effect: { energy: 3, heal: 3 } },
  { paar: [4, 5], naam: 'Liefde geeft stem', effect: { buffType: { type: 'p', amt: 3, turns: 1 } } },
  { paar: [5, 6], naam: 'Woord opent inzicht', effect: { buffType: { type: 'p', amt: 3, turns: 1 } } },
  { paar: [6, 7], naam: 'Inzicht opent verbinding', effect: { verbinding: 10 } },
];

/**
 * Volledige balans — alle 7 origins in 1 beurt (§14 / §3.5).
 * Tegen gewone bazen: −25 HP. Tegen Theluun: +20 Verbinding (§13).
 * Altijd: alle blokkades weg + alle 7 mantra-tonen.
 */
export const VOLLEDIGE_BALANS = {
  naam: 'Volledige Balans',
  dmgNormaal: 25,
  verbindingTheluun: 20,
  cleanse: 'all' as const,
  allTones: true,
};

/**
 * MEGA COMBO (§13) — alleen in de Theluun-fight: de 4 meesterschapskaarten
 * Aardeanker + Open Hart + Zuivere Stem + Helder Zien in dezelfde beurt → +40
 * Verbinding direct.
 */
export const MEGA_COMBO = {
  naam: 'MEGA COMBO',
  kaartIds: ['ch1-aardeanker', 'ch4-open-hart', 'ch5-zuivere-stem', 'ch6-helder-zien'],
  verbinding: 40,
};

/** Aantal verschillende types dat een 5-type-combo triggert (§3.5). */
export const TYPE_COMBO_DREMPEL = 5;
